import HomePage from "@pages/index";

export const HomeView = {
	path: "/home",
	name: "home",
	component: HomePage,
	meta: {
		title: "Home"
	},
};